import { forwardRef } from 'react';

export const PenthouseIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 38.3941C0 38.0563 0.273845 37.7825 0.61165 37.7825H41.3884C41.7262 37.7825 42 38.0563 42 38.3941C42 38.7319 41.7262 39.0058 41.3884 39.0058H0.61165C0.273845 39.0058 0 38.7319 0 38.3941Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.99622 5.60964C3.99622 5.27183 4.27006 4.99799 4.60787 4.99799H36.7807C37.1185 4.99799 37.3923 5.27183 37.3923 5.60964V35.3766C37.3923 35.7144 37.1185 35.9883 36.7807 35.9883H4.60787C4.27006 35.9883 3.99622 35.7144 3.99622 35.3766V5.60964ZM5.21952 6.22129V34.765H36.169V6.22129H5.21952Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85059 8.91262C6.85059 8.57481 7.12443 8.30096 7.46224 8.30096H11.336C11.6738 8.30096 11.9477 8.57481 11.9477 8.91262V14.2544C11.9477 14.5922 11.6738 14.866 11.336 14.866H7.46224C7.12443 14.866 6.85059 14.5922 6.85059 14.2544V8.91262ZM8.07389 9.52427V13.6427H10.7244V9.52427H8.07389Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.313 8.91262C14.313 8.57481 14.5868 8.30096 14.9246 8.30096H18.7984C19.1362 8.30096 19.4101 8.57481 19.4101 8.91262V14.2544C19.4101 14.5922 19.1362 14.866 18.7984 14.866H14.9246C14.5868 14.866 14.313 14.5922 14.313 14.2544V8.91262ZM15.5363 9.52427V13.6427H18.1868V9.52427H15.5363Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7744 8.91262C21.7744 8.57481 22.0483 8.30096 22.3861 8.30096H26.2599C26.5977 8.30096 26.8715 8.57481 26.8715 8.91262V14.2544C26.8715 14.5922 26.5977 14.866 26.2599 14.866H22.3861C22.0483 14.866 21.7744 14.5922 21.7744 14.2544V8.91262ZM22.9977 9.52427V13.6427H25.6482V9.52427H22.9977Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.2367 8.91262C29.2367 8.57481 29.5105 8.30096 29.8483 8.30096H33.7221C34.0599 8.30096 34.3338 8.57481 34.3338 8.91262V14.2544C34.3338 14.5922 34.0599 14.866 33.7221 14.866H29.8483C29.5105 14.866 29.2367 14.5922 29.2367 14.2544V8.91262ZM30.46 9.52427V13.6427H33.1105V9.52427H30.46Z"
        />
        <path d="M11.3361 17.1088H7.46228V22.4505H11.3361V17.1088Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85059 17.1088C6.85059 16.771 7.12443 16.4971 7.46224 16.4971H11.336C11.6738 16.4971 11.9477 16.771 11.9477 17.1088V22.4505C11.9477 22.7883 11.6738 23.0622 11.336 23.0622H7.46224C7.12443 23.0622 6.85059 22.7883 6.85059 22.4505V17.1088ZM8.07389 17.7204V21.8389H10.7244V17.7204H8.07389Z"
        />
        <path d="M18.7983 17.1088H14.9246V22.4505H18.7983V17.1088Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.313 17.1088C14.313 16.771 14.5868 16.4971 14.9246 16.4971H18.7984C19.1362 16.4971 19.4101 16.771 19.4101 17.1088V22.4505C19.4101 22.7883 19.1362 23.0622 18.7984 23.0622H14.9246C14.5868 23.0622 14.313 22.7883 14.313 22.4505V17.1088ZM15.5363 17.7204V21.8389H18.1868V17.7204H15.5363Z"
        />
        <path d="M26.2599 17.1088H22.3861V22.4505H26.2599V17.1088Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7744 17.1088C21.7744 16.771 22.0483 16.4971 22.3861 16.4971H26.2599C26.5977 16.4971 26.8715 16.771 26.8715 17.1088V22.4505C26.8715 22.7883 26.5977 23.0622 26.2599 23.0622H22.3861C22.0483 23.0622 21.7744 22.7883 21.7744 22.4505V17.1088ZM22.9977 17.7204V21.8389H25.6482V17.7204H22.9977Z"
        />
        <path d="M33.7222 17.1088H29.8484V22.4505H33.7222V17.1088Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.2367 17.1088C29.2367 16.771 29.5105 16.4971 29.8483 16.4971H33.7221C34.0599 16.4971 34.3338 16.771 34.3338 17.1088V22.4505C34.3338 22.7883 34.0599 23.0622 33.7221 23.0622H29.8483C29.5105 23.0622 29.2367 22.7883 29.2367 22.4505V17.1088ZM30.46 17.7204V21.8389H33.1105V17.7204H30.46Z"
        />
        <path d="M11.3361 25.3456H7.46228V31.0951H11.3361V25.3456Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85059 25.3455C6.85059 25.0077 7.12443 24.7339 7.46224 24.7339H11.336C11.6738 24.7339 11.9477 25.0077 11.9477 25.3455V31.0951C11.9477 31.4329 11.6738 31.7067 11.336 31.7067H7.46224C7.12443 31.7067 6.85059 31.4329 6.85059 31.0951V25.3455ZM8.07389 25.9572V30.4834H10.7244V25.9572H8.07389Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.313 25.3455C14.313 25.0077 14.5868 24.7339 14.9246 24.7339H18.7984C19.1362 24.7339 19.4101 25.0077 19.4101 25.3455V35.295C19.4101 35.6329 19.1362 35.9067 18.7984 35.9067H14.9246C14.5868 35.9067 14.313 35.6329 14.313 35.295V25.3455ZM15.5363 25.9572V34.6834H18.1868V25.9572H15.5363Z"
        />
        <path d="M26.2599 25.3456H22.3861V31.0951H26.2599V25.3456Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7744 25.3455C21.7744 25.0077 22.0483 24.7339 22.3861 24.7339H26.2599C26.5977 24.7339 26.8715 25.0077 26.8715 25.3455V31.0951C26.8715 31.4329 26.5977 31.7067 26.2599 31.7067H22.3861C22.0483 31.7067 21.7744 31.4329 21.7744 31.0951V25.3455ZM22.9977 25.9572V30.4834H25.6482V25.9572H22.9977Z"
        />
        <path d="M33.7222 25.3456H29.8484V31.0951H33.7222V25.3456Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.2367 25.3455C29.2367 25.0077 29.5105 24.7339 29.8483 24.7339H33.7221C34.0599 24.7339 34.3338 25.0077 34.3338 25.3455V31.0951C34.3338 31.4329 34.0599 31.7067 33.7221 31.7067H29.8483C29.5105 31.7067 29.2367 31.4329 29.2367 31.0951V25.3455ZM30.46 25.9572V30.4834H33.1105V25.9572H30.46Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.99622 3.61165C3.99622 3.27385 4.27006 3 4.60787 3H36.7807C37.1185 3 37.3923 3.27385 37.3923 3.61165V5.60971C37.3923 5.94751 37.1185 6.22136 36.7807 6.22136H4.60787C4.27006 6.22136 3.99622 5.94751 3.99622 5.60971V3.61165ZM5.21952 4.2233V4.99806H36.169V4.2233H5.21952Z"
        />
      </svg>
    );
  },
);
